import { flagState } from '@mail/flags';
import { IS_SOCIAL_USER } from 'reactApp/appHelpers/configHelpers';
import { DUPLICATES_LIMIT_VIA_MAIL_FLAGS } from 'reactApp/appHelpers/featuresHelpers/features/duplicates';
import { FLAGS_MAP } from 'reactApp/modules/mailFlags/constants';
import { store as reduxStore } from 'reactApp/store';
import {
    getDuplicatesRemovedGroupsCountViaLS,
    setDuplicatesRemovedGroupsCountViaLS,
} from 'reactApp/ui/Duplicates/DuplicatesRemoveLimitModal/DuplicatesRemoveLimitModal.helpers';

export const {
    getFlagShowCounter: getDuplicatesRemovedGroupsCountViaMailFlags,
    updateFlagShowCounter: setDuplicatesRemovedGroupsCountViaMailFlags,
} = flagState<typeof FLAGS_MAP>({
    flagKey: FLAGS_MAP['602'],
});

export const getDuplicatesRemovedGroupsCount = async () => {
    if (DUPLICATES_LIMIT_VIA_MAIL_FLAGS && !IS_SOCIAL_USER) {
        return (await getDuplicatesRemovedGroupsCountViaMailFlags()) ?? 0;
    }

    return Number(reduxStore.dispatch(getDuplicatesRemovedGroupsCountViaLS())) ?? 0;
};

export const setDuplicatesRemovedGroupsCount = async (count: number) => {
    if (DUPLICATES_LIMIT_VIA_MAIL_FLAGS && !IS_SOCIAL_USER) {
        await setDuplicatesRemovedGroupsCountViaMailFlags(count);
        return;
    }

    reduxStore.dispatch(setDuplicatesRemovedGroupsCountViaLS(count));
};
